
/**
 * Initialize any table as a Data Table by setting the `data-behavior` attribute to `data-table`.
 * E.g.
 * <table data-behavior="data-table >
 *   ....
 * </table>
 */
$(document).on('turbolinks:load', function() {
  require('datatables.net');
  require('datatables.net-zf');

  if ($.fn.DataTable) {
    $('[data-behavior=data-table]').DataTable({searching: false, paging: false, info: false});
  }
});
